import React from 'react';
import Header from './Header';
import ReportTitle from '../common/ReportTitle';
import OverallProgress from './OverallProgress';
import Grid from './Grid';
import ReportFilterTags from '../common/ReportFilterTags';

const ClassroomReport: React.FC = () => (
  <>
    <Header />
    <ReportTitle />
    <ReportFilterTags printOnly />
    <OverallProgress />
    <Grid />
  </>
);

export default ClassroomReport;
